import { LoginService } from 'src/app/components/Shared/Service/login_service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr';
import beautify from 'xml-beautifier';
import { FxcrsD_UService } from 'src/app/components/Shared/Service/FxcrsD_Uservice';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSelectChange, MatTableDataSource } from '@angular/material';
import { DashboarduiService } from '../../Shared/Service/dashboardui.service';
import { interval } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
}
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-restriction-syncfx-su',
  templateUrl: './restriction-syncfx-su.component.html',
  styleUrls: ['./restriction-syncfx-su.component.css'],
  providers: [FxcrsD_UService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]

})
export class RestrictionSyncfxSuComponent implements OnInit {
  apiresult: any;
  hotellistproperty: any;
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
  ValSearchUpload: string;
  filterProperty: any;
  today = new Date();
  hotelSearchDataStatus: any;
  productType: any;
  heartBeatData: any;
  excelFunction: boolean = false;
  payloadRequest: any;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private _APISERVICE: FxcrsD_UService, private datePipe: DatePipe, public loginService: LoginService) { }
  PGF: any
  PGT: any
  totalcount: any = 0;
  lstgetcmlist1: any = [] = [];
  pageSize = 50;
  PMS_NUB: any
  dropdownSettings = {};
  Check: boolean = false;
  selectedChannel: any;
  defaultData: any = [] = [];
  p: Number = 1;
  count: Number = 50;
  User: string;
  public status: string;
  public header: string;
  rateCode: string;
  selectedDate: any = new Date();
  selectedTOODate: any = new Date();
  todayFuture:any = new Date();
  todayFutureOneDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() + 1));
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  public LOGS: any;
  hotellistCopy: any = [] = [];
  Val: string;
  lstTCTOPMSCopy: any = [] = [];
  hotellist: any = [] = [];
  allproperty: any[];
  selected1: string;
  selected: string;
  SourceBy: string;
  selectedItems: string;
  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  display: Boolean = false;
  displayedColumns: string[] = ['status','echotoken','cM_Sync_Sts','fX_ET','reqdt','resdt','CreatedDate','postedDT','FXPayloadJSON','RequestJSON','ResJSON' ];

  Userid: any = [];
  /* Search Field */
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  dropdownDeptData: any;
  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean;
  XMLName:any
  searchBarFilter: boolean = false;
  addBtnDisabledFunc: boolean = true;
  hideSearchFilter(){
    this.ValSearchUpload = '';
    this.searchBarFilter = false
    
  }
  ngOnInit() {

    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.callIDSUsersProperties();
    this.dropdownSettingsDept = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.GetPropSyncFXSU()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          this.apiresult = data;
          this.dropdownDeptData = this.apiresult
          this.hotellistproperty = this.hotellist;
          this.isProgressing = false;
        });

  }

  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      this.searchBarFilter = false
      this.ValSearchUpload = '';
      
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        this.totalcount = 0
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('pms code value = ', this.Pmscodevalue)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.addBtnDisabledFunc = false
        // For Online Status
        this.apiCallIdsService
          .readHotelSearch(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHotelSearch =', data)
            this.hotelSearchDataStatus = data[0].recordstatus
            this.productType = data[0].producttype
          });
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data[0])
            this.heartBeatData = data[0].heartBeat


            // For blinking the record
            const today = new Date()
            console.log('Today Date = ', today);
            this.currentDateStore = today.toLocaleTimeString('it-IT')
            console.log('Today Date = ', this.currentDateStore);
            this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
            var start = this.storeHeartBeatValue.split(":");
            var end = this.currentDateStore.split(":");
            var startDate = new Date(0, 0, 0, start[0], start[1], 0);
            var endDate = new Date(0, 0, 0, end[0], end[1], 0);
            var diff = endDate.getTime() - startDate.getTime();
            var hours = Math.floor(diff / 1000 / 60 / 60);
            diff -= hours * 1000 * 60 * 60;
            var minutes = Math.floor(diff / 1000 / 60);
            // console.log('minutes difference',minutes)
            console.log('minutes difference', hours + ":" + minutes)
            if ((hours + ":" + minutes) > "0:30") {
              console.log('blinkOfflineHotel true')
              this.blinkOfflineHotel = true
            } else {
              console.log('blinkOfflineHotel false')
              this.blinkOfflineHotel = false
            }


          });
        interval(2000 * 60).subscribe(() => {
          this.heartbeatFunction();
        });
      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.addBtnDisabledFunc = true
        this.excelFunction = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  heartbeatFunction() {
    this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =', data[0])
        this.heartBeatData = data[0].heartBeat
      });
  }


  Search(event: any) {
    this.hotellist = this.hotellistproperty.filter((res: { pmscode: { toString: () => string; }; pmsname: { toString: () => string; } }) => {
      return res.pmscode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.pmsname.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
    });
    if (event == '') {
      this.Val = '';
      // this.callIDSUsersProperties();
    }
  }

  SearchUpload(event: any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { fxresnub: { toString: () => string; }; pmsresnub: { toString: () => string; }; }) => {
      return res.fxresnub.toString().toLocaleLowerCase().match(this.ValSearchUpload.toLocaleLowerCase()) || res.pmsresnub.toString().toLocaleLowerCase().match(this.ValSearchUpload.toLocaleLowerCase());
    });
    if (event == '') {
      console.log('if search')
      this.ValSearchUpload = '';
    }
  }

  GetCommonMethodForLog() {
    this.searchBarFilter = true
    this.PGF = "0";
    this.PGT = "50";
    this.GetFXCRSDown();
  }
  GetFXCRSDown() {
    this.isProgressing = true;

    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');

    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');

    }
    else {
      this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    }
this.payloadRequest = {
  "PMSCODE":this.Pmscodevalue,
  "FRMDATE":this.selectedDate,
  "TOODATE":this.selectedTOODate
}
    this.apiCallIdsService.ReadResSyncfromFXtoSU(this.payloadRequest)
      .subscribe(
        data => {
          console.log(data);
          if (data.length < 1) {
            this.displayContent = false
            this.excelFunction = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
            // this.toastr.error('No data for enterted date range');
            // this.isProgressing=false;
          }
          else {
            this.errorMsgSubscription = false
            this.displayContent = true
            this.excelFunction = true
            this.idsProductList = data;
            this.filterProperty = data
            this.totalcount = data.length;
            // this.searchDownload = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data Loaded Successfully');
            this.isProgressing = false;
          }
        });
  }

  pageEvent(e: any) {
    console.log('pageEvent = ', e)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.PGF = this.pageSize * pageIndex + 1;
    this.PGT = this.PGF + e.pageSize - 1;
    console.log("this.PGF", this.PGF)
    console.log("this.PGT", this.PGT)
    this.GetFXCRSDown();
  }

  GetParseonlyDateTime(d: any) {
    console.log('GetParseonlyDateTime call', d.substring(12))
    return (d.substring(12));
  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }


  loadXMLData(Type:any,id: any) {
    this.isProgressing = true;
    this.apiCallIdsService.getResSyncfromFXtoSUJSON(id,Type)
        .subscribe((res) => {
          console.log('Response =', res[0])
          if(res[0].xmlData || res[0].jsonData){
            if(Type == 'RequesttoSU'){
              const xml = beautify(res[0].jsonData);
              console.log('Beautifier', xml);
            this.defaultData = xml;
              this.XMLName = "Request to SU"
            }else if(Type == 'SUResponse'){
              const xml = beautify(res[0].jsonData);
              console.log('Beautifier', xml);
              this.defaultData = xml;
              this.XMLName = "SU Response"
            }
            else if(Type == 'FXXML'){
              const xml = beautify(res[0].xmlData);
              console.log('Beautifier', xml);
            this.defaultData = xml;
              this.XMLName = "FX XML"
            }
            this.display = true;
            this.isProgressing = false;
          }else{
            this.toastr.error('No Data Found')
            this.isProgressing = false;
          }
          
        })
  }
}



